import Head from 'next/head'
import { 
  getServerSideProps as getProps,
  getServerSidePropsForStory as getStoryProps,
} from '../../graphql/investigation'
import AppChrome from '../../components/AppChrome'
import Hero from '../../components/Hero'
import Article from '../../components/article/Article'
import LinksSection from '../../components/LinksSection'

function Investigation( { entry: investigation } ) {
  return (
    <AppChrome
      metaTags={ {
        url: `https://${ process.env.NEXT_PUBLIC_APP_HOSTNAME }/investigations/${ investigation.slug }`,
        title: `${ investigation.title } — Finance Uncovered`,
        image: investigation.mainImage[ 0 ].url,
      } }
    >
      <Head>
        <title>{ investigation.title } — Finance Uncovered</title>
      </Head>
      <article>
        <Hero
          title={ investigation.title }
          intro={ investigation.introCopy }
        />
        <Article
          articleInfo={ investigation.entryInfo }
          articleContent={ investigation.articleContent }
          gridType="normal"
          darkMode
          isArticle
        />
        { investigation.linksSection.length && (
          <LinksSection
            sectionTitle={ investigation.linksSection[ 0 ].sectionTitle }
            links={ investigation.linksSection[ 0 ].links }
          />
        ) }
      </article>
    </AppChrome>
  )
}

export const getServerSideProps = async ctx => {
  const props = await getProps( ctx )

  if ( !props?.props?.entry ) {
    const storyProps = await getStoryProps( ctx )

    if ( storyProps?.props?.entry ) {
      return {
        redirect: {
          permanent: true,
          destination: `/stories/${ storyProps.props.entry.slug }`,
        },
        props: {},
      }
    }

    ctx.res.statusCode = 404
    props.props.status = 404
  }

  return props
}

export default Investigation
